/**
 * Componente para manejar el layout responsive
 * Basado en Slides.cs
 */

import { useEffect, ReactNode } from 'react';
import { useScreenOrientation } from '../../hooks/useScreenOrientation';
import './LayoutManager.css';

interface LayoutManagerProps {
  children: ReactNode;
}

export function LayoutManager({ children }: LayoutManagerProps) {
  const orientation = useScreenOrientation();

  useEffect(() => {
    // Ajustar clases del body según orientación
    document.body.className = `orientation-${orientation}`;
    
    return () => {
      document.body.className = '';
    };
  }, [orientation]);

  return (
    <div className={`layout-manager ${orientation}`}>
      {children}
    </div>
  );
}


